var map = {
	"./AU.svg": 760,
	"./ES.svg": 761,
	"./GB.svg": 762,
	"./HK.svg": 763,
	"./JP.svg": 764,
	"./MY.svg": 765,
	"./SG.svg": 766,
	"./US.svg": 767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;